<template>
    <div style="background: #f2f2f2"  v-loading="loading">
        <!--主体开始-->
        <div class="nding">
            <div>
                <p>当前位置：</p>
                <a href="/home">首页</a>&gt; <a href="/agricultural/index">农技服务</a>&gt; <a href="/agricultural/expertlist">农技专家</a>&gt; <a href="">专家详情</a>
            </div>
        </div>
        <section class="section ncontainer5">
            <div class="neit">
                <div class="wendaxq">
                    <div class="zuo">
                        <div class="xq11 ">
                            <div>
                                <div class="z">
                                    <div class="tu"> <img :src="$util.img(model.image)" alt=""> </div>
                                    <ul style="width:80%">
                                        <li>
                                            <img src="@/assets/styles/images/wenda3.png" alt="">
                                            <p>{{model.name}}·{{model.title}}</p>
                                        </li>
                                        <!-- <li>
                                            <img src="@/assets/styles/images/wenda2.png" alt="">
                                            <p>陕西省大荔县范家镇</p>
                                        </li> -->
                                        <li>
                                            <img src="@/assets/styles/images/wenda1.png" alt="">
                                            <p>{{model.unit}}</p>
                                        </li>
                                        <li>
                                            <img src="@/assets/styles/images/wenda0.png" alt="">
                                            <p>擅长：{{model.expert_in}}</p>
                                        </li>
                                    </ul>
                                </div>
                                <a class="shoucang">
                                    <div class="img1" v-if="!isshow" @click="collection(1)">关注</div>
                                    <div class="img2" v-if="isshow" @click="collection(0)">已关注</div>
                                </a>
                                <button class="ClickMe">我要提问</button>
                            </div>
                            <div class="jian">
                                <p style="word-break: break-all;"><em>简介：</em>{{model.describe}}</p>
                            </div>
                            <div class="zh">
                                <h2>{{model.askCount}}<span>咨询量</span></h2>

                                <h2>{{model.answer_rate}}<span>回复率</span></h2>
                            </div>
                        </div>
                        <div class="xq3">
                            <div class="title">
                                <div class="z">
                                    <h2> 专家<span>问答</span></h2>
                                </div>
                            </div>
                            <ul class="wenda">
                                <li v-for="item in questionPage" :key='item.id'>
                                    <a :href="'/agricultural/questiondetails?id='+item.id">
                                        <div class="wen">
                                            <span>问</span>
                                            <p>{{item.content}}</p>
                                        </div>
                                        <div class="da">
                                            <span>答</span>
                                            <p>{{item.answer_content}}</p>
                                        </div>
                                        <div class="xia">
                                            <p>全部{{item.answer_count}}条信息</p>
                                            <p>更新于{{ $util.timeStampTurnTime(item.answer_time, 'YYYY-MM-DD') }}</p>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                            <div class="pages">
                                <div class="Pagination"></div>
                                <!-- <div class="searchPage"> <span class="page-sum">共<strong class="allPage">{{pageCount}}</strong>页</span></div> -->
                            </div>
                        </div>
                    </div>
                    <div class="you">
                        <h2><span>推荐文章</span></h2>
                        <ul>
                            <li v-for="item in recommentList" :key="item.id">
                                <a :href="'/information/details?id='+item.id">
                                    <div class="tu"> <img :src="$util.img(item.image)" alt=""> </div>
                                    <p>{{item.title}}</p>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <!--提问弹出层-->
        <div id="goodcover"></div>
        <div id="code" style="width: 600px; height: 600px">
        <div class="close"><a href="javascript:void(0)" id="closebt"><img src="@/assets/styles/images/close.png" alt=""></a></div>
        <div class="zixun">
            <h4>提问专家</h4>
            <section class="box-group">
                <section class="item-group">
                <label> 咨询类型 </label>
                <select v-model="data.pid" name="side" @change="getchild()">
                    <option value="" selected>请选择</option>
                    <option  v-for="item in typeList" :key="item.tid" :value="item.tid">{{item.typename}}</option>
                </select>
                 <select v-model="data.tid" name="side">
                    <option value="">请选择</option>
                    <option v-for="item in childtypeList" :key="item.tid" :value="item.tid">{{item.typename}}</option>
                </select>
                </section>
                <section class="item-group item-group-desc">
                    <label> 问题描述 </label>
                    <section class="desc-group">
                        <textarea v-model="data.content" name="desc" placeholder='请详细描述要咨询的问题。' maxlength="200"></textarea>
                        <section class='img_box'>
                        <el-upload
                        :action="uploadActionUrl"
                        :limit="imgCount"
                        multiple
                        :on-exceed="handleExceed"
                        list-type="picture-card"
                        accept=".jpg,.jpeg,.png,.gif,.bmp"
                        :on-preview="handlePictureCardPreview"
                        :on-success="handleSuccess"
                        :before-upload="beforeAvatarUpload"
                        :on-remove="handleRemove">
                        <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog :visible.sync="dialogVisible" ><img width="100%" :src="dialogImageUrl" alt="" ></el-dialog>
                        <button class='submit_btn' @click="addQuestion()">提交</button>
                        </section>
                    </section>
                    <div style="margin-top: -13px;" class="el-upload__tip">提示：图片请上传jpg/jpeg/png/gif/bmp类型的文件，最多上传9张。</div>
                </section>
            </section>
        </div>
        </div>
    </div>
</template>

<style>
.el-upload-list--picture-card .el-upload-list__item {
    height: 90px;
}
.el-upload--picture-card {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 90px;
    height: 90px;
    cursor: pointer;
    line-height: 90px;
    vertical-align: top;
}
</style>

<script>
    import '@/assets/styles/js/jquery.pagination.js';
    import Config from '@/utils/config';
    import { getToken } from "@/utils/auth.js";
    import { expertDetail, expertCollection } from '@/api/expert/expert';
    import { questionPage } from '@/api/expert/question';
    import { addQuestion } from '@/api/expert/question';
    import { informationList } from '@/api/information/information'; 
    import { publictypeList } from '@/api/publicType/publicType';

    export default {
        name: '',
        components: {},
        data: () => {
            return {
                loading: true,
                id: 0,
                model:{},
                recommentList:[],
                questionPage:[],
                typeList:[],
                childtypeList:[],
                pageCount:0,
                page_size:10,
                page:1,
                token:'',
                data:{pid:'', tid:''},
                isshow: false,
                
                imgCount:9,
                imgList: [],
                dialogImageUrl: '',
			    dialogVisible: false,
                uploadActionUrl: Config.baseUrl + '/api/upload/questionImg',
            };
        },
        created() {
            this.id = this.$route.query.id;
            this.token = getToken();
            this.getdetails();
            this.getquestionPage();
            this.getrecommentList();
            this.gettypeList(2);
        },
        methods: {
            getdetails() {
                expertDetail({
                    id: this.id
                }).then(res => {
                    if(res.code == 0) {
                        this.model = res.data;
                        this.isshow = this.model.iscollection;

                        let wintitle = `${window.document.title}`;
                        let title = wintitle.split('-')
                        window.document.title = this.model.name + ' - ' + title[1];
                    }
                }).catch(err => {
                    //this.$message.error(err.message);
                });
            },
            getquestionPage() {
                questionPage({
                    page_size: this.page_size,
                    page: this.page,
                    eid: this.id
                }).then(res => {
                    if(res.code == 0) {
                        this.pageCount = res.data.page_count;
                        $(".Pagination").pagination(this.pageCount, {
                            callback: this.changepage
                        });
                        $(".allPage").text(this.pageCount);
                        this.questionPage = res.data.list;
                        this.loading = false;
                    }
                }).catch(err => {
                    this.loading = false;
                    //this.$message.error(err.message);
                });
            },
            changepage(page_id) {
                this.loading = true;
                this.page = page_id + 1;
                questionPage({
                    page_size: this.page_size,
                    page: this.page,
                    eid: this.id
                }).then(res => {
                    if(res.code == 0) {
                    this.questionPage = res.data.list;
                    this.loading = false;
                    }
                });
            },
            getrecommentList() {
                informationList({
                    typenumber: "10003",
                    recomment: true,
                    isImg: true,
                    limit: 5
                    }).then(res => {
                    if(res.code == 0) {
                        this.recommentList = res.data;
                    }
                });
            },
            collection(type) {
                if(util.isEmpty(this.token))
                {
                    //this.$message.warning("还未登录，请先登录！");
                    location.href = '/login?redirect=' + this.$route.fullPath;
                    return;
                }
                var params = {};
                var msg = "关注成功！";
                if(type == 1) {
                    this.isshow = true;
                    params = {id:this.id};
                }
                else {
                    this.isshow = false;
                    params = {id:this.id, iscancel:1};
                    msg = "取消成功！"
                }
                expertCollection(params).then(res => {
                    if(res.code == 0) {
                        this.$message.success(msg);
                    }
                    else {
                        this.$message.warning(res.message);
                    }
                })
            },           
            gettypeList(level, pid) { 
                publictypeList({
                    typenumber: "10004",
                    level: level,
                    parent_id : pid
                }).then(res => {
                    if(res.code == 0) {
                        if(util.isEmpty(pid))
                        {
                            this.typeList = res.data;
                        }
                        else
                        {
                            this.childtypeList = res.data;
                        }                      
                    }
                })
            },
            getchild(){
                if(!util.isEmpty(this.data.pid))
                {
                    this.gettypeList(3, this.data.pid);
                }
                else
                {
                    this.data.tid = '';
                    this.childtypeList = [];
                }
                
            },
            addQuestion() {
                if(util.isEmpty(this.token))
                {
                    this.$message.warning("还未登录，请先登录！");
                    return;
                }
                if(util.isEmpty(this.data.tid))
                {
                    this.$message.warning("请选择咨询类型！");
                    return;
                }
                if(util.isEmpty(this.data.content))
                {
                    this.$message.warning("请填写问题描述！");
                    return;
                }
                var image = '';
                this.imgList.forEach(item => {
                     image += (!util.isEmpty(image) ? '|' : '') + item.url;
                });
                addQuestion({
                    tid: this.data.tid,
                    eid: this.id,
                    content: this.data.content,
                    image: image
                }).then(res => {
                    if(res.code == 0) {
                        this.$message.success("提交成功！");
                        location.reload();
                    }
                    else {
                        this.$message.error(res.message);
                    }
                }).catch(err => {
                    this.$message.error(err.message);
                });
            },
            handleSuccess(response, file, fileList){
                var img = {name:response.data.pic_name, url:response.data.pic_path};
                this.imgList.push(img);
                this.checkCount();
            },
            handleRemove(file, fileList) {
                var imgs = [];
                fileList.forEach(item => {
                    var img = this.imgList.filter(function (a) {
                        return a.name == item.name;
                    });  
                    if(img.length >0)
                    {
                        imgs.push(img[0]);
                    }             
                });
                this.imgList = imgs;
                this.checkCount();
            },
            beforeAvatarUpload(file) {
                if(file.type!='image/jpg' && file.type!='image/jpeg' && file.type!='image/png' && file.type!='image/gif' && file.type!='image/bmp') {
                    this.$message.error('请上传正确格式的图片!');
                    return false;
                }
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleExceed(file, fileList) {
			    // 图片数量大于9
			    this.$message.error('上传图片最大数量为'+this.imgCount+'张');
		    },
            checkCount() {
                if(this.imgList.length>=this.imgCount){
                    $('.el-icon-plus').parent().hide();
                }
                else {
                    $('.el-icon-plus').parent().show();
                }
            }
        },
        mounted () {
            var _that = this;
            $(function() {
                $('.ClickMe').click(function() {
                    if(util.isEmpty(_that.token))
                    {
                        //_that.$message.warning("还未登录，请先登录！");
                        location.href = '/login?redirect=' + _that.$route.fullPath;
                        return;
                    }
                    $('#code').center();
                    $('#goodcover').show();
                    $('#code').fadeIn();
                });
                $('#closebt').click(function() {
                    $('#code').hide();
                    $('#goodcover').hide();
                });
                $('#goodcover').click(function() {
                    $('#code').hide();
                    $('#goodcover').hide();
                });
                jQuery.fn.center = function(loaded) {
                    var obj = this;
                    var body_width = parseInt($(window).width());
                    var body_height = parseInt($(window).height());
                    var block_width = parseInt(obj.width());
                    var block_height = parseInt(obj.height());

                    var left_position = parseInt((body_width / 2) - (block_width / 2) + $(window).scrollLeft());
                    if (body_width < block_width) {
                        left_position = 0 + $(window).scrollLeft();
                    };

                    var top_position = parseInt((body_height / 2) - (block_height / 2) + $(window).scrollTop());
                    if (body_height < block_height) {
                        top_position = 0 + $(window).scrollTop();
                    };

                    if (!loaded) {

                        obj.css({
                            'position': 'absolute'
                        });
                        obj.css({
                            'top': ($(window).height() - $('#code').height()) * 0.5,
                            'left': left_position
                        });
                        $(window).bind('resize', function() {
                            obj.center(!loaded);
                        });
                        $(window).bind('scroll', function() {
                            obj.center(!loaded);
                        });

                    } else {
                        obj.stop();
                        obj.css({
                            'position': 'absolute'
                        });
                        obj.animate({
                            'top': top_position
                        }, 200, 'linear');
                    }
                }

            });
        },

    }
</script>
